import React from 'react';
import {Settings} from '../../components/Settings';

export const SettingsPage = () => {
  return <Settings />;
};
